import React, { useState, useEffect, useCallback, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'
import { PurchaseTypes } from 'Redux/purchases'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from 'moment'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import * as Sentry from 'Services/sentry'
import { TicketActions } from 'Redux/ticket'
import { ReactComponent as CartRepeatIcon } from 'Assets/Icons/CartRepeatBlack.svg'
import { ReactComponent as EmptyCart } from 'Assets/Icons/EmptyCart.svg'
import { ReactComponent as CheckQA } from 'Assets/Icons/CheckQA.svg'
import { ReactComponent as Download } from 'Assets/Icons/Descargar.svg'
import { ReactComponent as Recepcionado } from 'Assets/Icons/EstadoRecepcionado.svg'
import { ReactComponent as ComplaintIcon } from 'Assets/Icons/Complaint.svg'
import { ReactComponent as Cancelado } from 'Assets/Icons/EstadoCancelado.svg'
import { ReactComponent as PorRecepcionar } from 'Assets/Icons/EstadoPorRecepcionar.svg'
import { ReactComponent as Tramitado } from 'Assets/Icons/EstadoTramitado.svg'
import { ReactComponent as NoDefinido } from 'Assets/Icons/EstadoNoDefinido.svg'
import { ReactComponent as Approval } from 'Assets/Icons/Approval.svg'
import ArrowDropdown from 'Assets/Icons/ArrowDropdown'
import { getDeliveryQa, getDeliveryQaExcel, getOrderProducts, getProviderOrdersExcel } from 'Services/api'
import {
  ORDER_STATUS,
  ROLES,
  ORDER_QUALITY_STATUS,
  PROVIDER_ORDERS_MODIFICATION_TYPE,
  ROLE_DESCRIPTION,
} from 'Config/constants'
import routes from 'Config/routes'
import colors from 'Assets/colors'
import { ModalRepeatOrder, ModalQAForm } from 'Components/molecules'
import { Modal, NumberFormat, ProductButton } from 'Components/atoms'
import useProductButton from 'Components/utils/useProductButton'
import { financial } from 'Components/utils/cartCalculator'
import ProductInfoLoader from 'Components/atoms/productInfoLoader'
import ProductNameLoader from 'Components/atoms/productNameLoader'
import ProductActionLoader from 'Components/atoms/productActionLoader'
import ActionButton from 'Components/atoms/actionButton'
import ModalDownloadEmail from 'Components/molecules/modalDownloadEmail'
import useIsMobile from 'hooks/useIsMobile'
import { isUserLogirest, isUserSupply } from 'Components/utils/roles'
import useCancelOrder from 'hooks/delivery/useCancelOrder'

import ModalCancelOrder from '../modalCancelOrder'

import {
  ProductsContainer,
  TableHeaderRow,
  TableHeaderItem,
  SingleProductRow,
  SingleProductRowCL,
  SingleProductNameHelper,
  SingleProductName,
  SingleProductPriceContainer,
  SingleProductQtyContainer,
  SingleProductTotalPrice,
  SingleProductTotalPriceSplit,
  SingleProductTotalQty,
  SingleProductButtonContainer,
  Price,
  PriceKG,
  MinAndMulti,
  RequestProviderInfoContainer,
  RequestProviderInfo,
  RequestProviderName,
  RequestProviderDeliveryDate,
  RequestProviderOrderNumber,
  ProviderDetail,
  TotalPrice,
  TotalProductLines,
  RequestOrderContainer,
  RequestRepeatOrderContainer,
  RequestActionContainer,
  RequestRepeatOrder,
  RequestActionOrderContainer,
  RequestActionOrder,
  HelpText,
  NotAvailable,
  NotAvailableLiteral,
  ShowProductsContainer,
  ShowMoreCopy,
  ShowLessCopy,
  useStyles,
  RequestActionButtonsContainer,
  RequestActionOrderContainerDisabled,
  RequestActionOrderDisabled,
  SingleProductNameLabelMobile,
  SingleProductTotalQtyLabelMobile,
  ButtonSection,
  RowSee,
  ProviderDetailSmall,
  RequestProviderDeliveryDateSmall,
  StateText,
  RequestProviderBy,
  RequestProviderLinkedOrder,
  DetailExtraService,
  ExtraDesc,
} from './styled'

const HistoryOrderProduct = ({ centerId, order, smallCard }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const isMobile = useIsMobile()

  const { onNext, onPreviuos, setRef } = useProductButton()
  const { showCancelOrder, cancelOrder, blockCancelOrderButton, hasNotServedNonConformity } = useCancelOrder(order)
  const notServedDisabledTooltip = blockCancelOrderButton
    ? t('orderHasCancellationRequest')
    : t('orderHasNotServedNonConformity')

  const [products, setProducts] = useState(null)
  const [totalPrice, setTotalPrice] = useState(null)
  const [totalProducts, setTotalProducts] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [productsLoading, setProductsLoading] = useState(false)
  const [openProducts, setOpenProducts] = useState(false)
  const [showQAModal, setShowQAModal] = useState(false)
  const [qaData, setQaData] = useState({})
  const [showDownloadQaExcelModal, setShowDownloadQaExcelModal] = useState(false)
  const [showDownloadProviderOrdersExcelModal, setShowDownloadProviderOrdersExcelModal] = useState(false)
  const [showCancelOrderModal, setShowCancelOrderModal] = useState(false)

  const user = useSelector(state => state.auth.user)
  const center = useSelector(state => state.auth.selectedCenter)
  const role = find(user.roles, elem => elem !== 'ROLE_USER')

  const classes = useStyles()

  const { showPrice } = center

  const isLogirestRole = useMemo(() => isUserLogirest(user), [user])
  const isSupplyRole = useMemo(() => isUserSupply(user), [user])

  useEffect(() => {
    if (openProducts) {
      setProductsLoading(true)
      getOrderProducts({}, centerId, order.id, order.documentTypeCode, order.documentCompany)
        .then(response => {
          setProducts(response)
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log('ERROR', error)
        })
        .finally(() => setProductsLoading(false))
    } else {
      setProducts(null)
    }
  }, [openProducts, centerId, order])

  useEffect(() => {
    if (products) {
      let total = 0
      get(products, 'lines', []).map(product => {
        const { price } = product
        total += price
        return null
      })
      setTotalPrice(total)
      setTotalProducts(get(products, 'lines', []).length)
    }
  }, [products])

  const onShowQA = useCallback(() => {
    getDeliveryQa(order.id, order.documentTypeCode, order.documentCompany, centerId)
      .then(response => {
        setQaData(response)
        setShowQAModal(true)
      })
      .catch(() => toast.error(t('petitionError')))
  }, [centerId, order.documentCompany, order.documentTypeCode, order.id, t])

  const onDownloadQA = useCallback(() => {
    getDeliveryQaExcel(order.id, order.documentTypeCode, order.documentCompany, centerId)
      .then(() => setShowDownloadQaExcelModal(true))
      .catch(e => {
        toast.error(t('petitionError'))
        Sentry.captureException(e)
      })
  }, [centerId, order.documentCompany, order.documentTypeCode, order.id, t])

  // eslint-disable-next-line react/prop-types
  const OrderState = ({ state, isDisabled = false }) => {
    const stateProps = {
      [ORDER_STATUS.PR]: {
        icon: <PorRecepcionar style={{ fill: !isDisabled ? colors.red : '#ddd' }} />,
        copy: smallCard ? t('receive') : t('orderStatusPR'),
        copyStef: t('orderStatusPRStef'),
        link: `/delivery/${order.id}/${order.documentTypeCode}/${order.documentCompany}/qa`,
      },
      [ORDER_STATUS.RC]: {
        icon: <Recepcionado style={{ fill: colors.secondary }} />,
        copy: t('orderStatusRC'),
      },
      [ORDER_STATUS.PE]: {
        icon: <Tramitado />,
        copy: t('orderStatusPE'),
      },
      [ORDER_STATUS.CN]: {
        icon: <Cancelado style={{ fill: colors.secondary }} />,
        copy: t('orderStatusCN'),
      },
      [ORDER_STATUS.OT]: {
        icon: <NoDefinido style={{ fill: colors.gray40l }} />,
      },
    }
    const { icon, copy, copyStef, link } = stateProps[state] || {
      icon: null,
      copy: '',
      copyStef: '',
      link: null,
    }

    const ActionOrder = () => (
      <RequestActionOrderContainer
        stateProp={state}
        role={ROLES[role]}
        openProducts={openProducts[order.id]}
        smallCard={smallCard}
        fillBackground={state === ORDER_STATUS.PR && smallCard}
      >
        <RequestActionOrder
          stateProp={state}
          smallCard={smallCard}
          fillBackground={state === ORDER_STATUS.PR && smallCard}
        >
          {!smallCard && icon}
          <StateText>{smallCard ? t('receive') : t(`orderStatus.${state}`)}</StateText>
        </RequestActionOrder>
        {!smallCard && (state !== ORDER_STATUS.RC || order.receptionFeedbackStatus === ORDER_QUALITY_STATUS.SC) ? (
          <HelpText>{ROLES[role] ? copyStef : copy}</HelpText>
        ) : (
          !smallCard && (
            <RequestActionButtonsContainer>
              <Button endIcon={<CheckQA />} className={classes.seeQA} onClick={onShowQA}>
                {t('seeQA')}
              </Button>
              <Button endIcon={<Download />} className={classes.seeQA} onClick={onDownloadQA}>
                {t('downloadQA')}
              </Button>
            </RequestActionButtonsContainer>
          )
        )}
      </RequestActionOrderContainer>
    )

    const ActionOrderDisabled = () => (
      <RequestActionOrderContainerDisabled
        stateProp={state}
        role={ROLES[role]}
        openProducts={openProducts[order.id]}
        smallCard={smallCard}
      >
        <RequestActionOrderDisabled stateProp={state} smallCard={smallCard}>
          {smallCard && icon}
          {t(`orderStatus.${state}`)}
        </RequestActionOrderDisabled>
      </RequestActionOrderContainerDisabled>
    )

    if (isDisabled) {
      return <ActionOrderDisabled />
    }

    if (link && !ROLES[role]) {
      return (
        <Link to={link} className='link'>
          <ActionOrder />
        </Link>
      )
    }
    return <ActionOrder />
  }

  const handleClickExcel = () => {
    getProviderOrdersExcel({}, centerId, order.id, order.documentTypeCode, order.documentCompany)
      .then(() => setShowDownloadProviderOrdersExcelModal(true))
      .catch(e => {
        toast.error(t('petitionError'))
        Sentry.captureException(e)
      })
  }

  const handleClickOpenCarts = () => {
    const requestOrderId = order.parentRequest
    history.push(routes.addCartsId(requestOrderId))
  }

  const handleClickRepeatOrder = () => {
    dispatch({
      type: PurchaseTypes.FETCH_REPEAT_ORDER,
      params: {
        orderId: order.id,
        documentTypeCode: order.documentTypeCode,
        documentCompany: order.documentCompany,
      },
    })
    setShowModal(false)
  }

  const handleClickOpenNoConformities = () => {
    const providerId = order.provider.id
    dispatch(TicketActions.setIsNotServedOrder(false))
    dispatch(TicketActions.setNonConformityOrder(order))
    history.push(routes.addTicketing(providerId, order.id, order.documentTypeCode, order.documentCompany))
  }

  const handleClickNotServidedOrder = () => {
    const providerId = order.provider.id
    dispatch(TicketActions.setIsNotServedOrder(true))
    dispatch(TicketActions.setNonConformityOrder(order))
    history.push(routes.addTicketing(providerId, order.id, order.documentTypeCode, order.documentCompany))
  }

  const handleClickPR = () => {
    history.push(`/delivery/${order.id}/${order.documentTypeCode}/${order.documentCompany}/qa`)
  }

  const onFilterClick = () => {
    setShowModal(true)
  }

  const handleNewOrder = () => {
    dispatch({ type: PurchaseTypes.FETCH_PREVIUS_ORDER_PROVIDERS, params: { order } })
    history.push(routes.previusOrder)
  }

  const handleChange = () => {
    setShowModal(false)
  }

  const handleCancelOrder = useCallback(() => {
    setShowCancelOrderModal(true)
  }, [])

  const ProductLinesPrice = () => {
    const textProduct =
      totalProducts === 1
        ? `${Math.abs(totalProducts)} ${t('product').toLowerCase()}`
        : `${Math.abs(totalProducts)} ${t('products').toLowerCase()}`
    return <TotalProductLines>{totalProducts ? textProduct : ' '}</TotalProductLines>
  }

  const handleClickSeeProducts = id => setOpenProducts({ ...openProducts, [id]: !openProducts[id] })

  const totalToShow = !totalPrice && order ? order.total : totalPrice

  const onLinkRedeliveryOrder = useCallback(async () => {
    dispatch({
      type: PurchaseTypes.LINK_ORDER_TO_CART,
      params: { orderId: order.id, documentTypeCode: order.documentTypeCode, documentCompany: order.documentCompany },
    })
  }, [dispatch, order.documentCompany, order.documentTypeCode, order.id])

  return (
    <>
      {smallCard && (
        <>
          <RequestProviderInfoContainer smallCard={smallCard}>
            <ProviderDetailSmall smallCard={smallCard}>
              <RowSee>
                <ShowProductsContainer onClick={() => handleClickSeeProducts(order.id)} smallCard={smallCard}>
                  <ArrowDropdown
                    fill={openProducts[order.id] ? colors.secondary : colors.black}
                    style={{
                      margin: '0 0.5rem',
                      transform: openProducts[order.id] ? 'rotate(180deg)' : 'none',
                      height: '20px',
                    }}
                  />
                  {openProducts[order.id] ? (
                    <ShowLessCopy>{t('contractProducts')}</ShowLessCopy>
                  ) : (
                    <ShowMoreCopy>{t('seeProducts')}</ShowMoreCopy>
                  )}
                </ShowProductsContainer>

                <RequestProviderDeliveryDateSmall>
                  {`${isMobile ? t('historyDeliveryDateSmall') : t('historyDeliveryDate')}: `}
                  {moment(order.delivery).format('DD/MM/YYYY')}
                </RequestProviderDeliveryDateSmall>
              </RowSee>

              {totalToShow && showPrice ? (
                <TotalPrice smallCard={smallCard}>
                  <NumberFormat value={totalToShow} />
                </TotalPrice>
              ) : null}
              <ProductLinesPrice />
            </ProviderDetailSmall>
            <ButtonSection smallCard={smallCard}>
              {ROLES.ROLE_STEF !== ROLES[role] &&
                order.state === ORDER_STATUS.PR &&
                showCancelOrder &&
                !blockCancelOrderButton && (
                  <ActionButton
                    onClick={handleCancelOrder}
                    buttonText={t('cancelOrder')}
                    helpText={t('cancelOrderHelp')}
                    Icon={Cancelado}
                    disabled={hasNotServedNonConformity}
                    disabledTooltip={t('orderHasNotServedNonConformity')}
                    smallCard={smallCard}
                  />
                )}
              {ROLES.ROLE_STEF !== ROLES[role] && order.state === ORDER_STATUS.PR && (
                <ActionButton
                  onClick={handleClickNotServidedOrder}
                  buttonText={t('notServidedOrderSmall')}
                  helpText={t('notServidedHelp')}
                  Icon={ComplaintIcon}
                  disabled={order?.blockOrderNotServedButton === true || blockCancelOrderButton}
                  disabledTooltip={notServedDisabledTooltip}
                  smallCard={smallCard}
                />
              )}

              {order.parentRequest && (
                <SeeApprovedRequestAction onClick={handleClickOpenCarts} type={order.modificationType} />
              )}
              {smallCard && order.state === ORDER_STATUS.PR ? (
                <ActionButton
                  onClick={handleClickPR}
                  buttonText={t('receive')}
                  helpText={t('receive')}
                  smallCard={smallCard}
                  status={ORDER_STATUS.PR}
                />
              ) : (
                <OrderState state={order.state} isDisabled={order?.blockReceptionButton} />
              )}
              <RequestOrderContainer openProducts={openProducts[order.id]} smallCard={smallCard} />
            </ButtonSection>
          </RequestProviderInfoContainer>
        </>
      )}

      {!smallCard && (
        <>
          <RequestProviderInfoContainer>
            <RequestProviderInfo>
              <RequestProviderName>{get(order, 'provider.name')}</RequestProviderName>
              {order?.redeliveryOrderRole && (
                <RequestProviderBy>
                  {t('orderBy', { orderBy: ROLE_DESCRIPTION[order.redeliveryOrderRole] })}
                </RequestProviderBy>
              )}
              <RequestProviderDeliveryDate>
                {t('historyDeliveryDate')} {moment(order.delivery).format('DD/MM/YYYY')}
              </RequestProviderDeliveryDate>
              <RequestProviderOrderNumber>
                {t('order')} {order.id}
              </RequestProviderOrderNumber>
              {order?.redeliveryOrder && (
                <RequestProviderLinkedOrder>
                  {t('linkOrder', { orderNumber: order?.redeliveryOrder.id })}
                </RequestProviderLinkedOrder>
              )}
            </RequestProviderInfo>
            <ProviderDetail>
              {totalToShow && showPrice ? (
                <TotalPrice>
                  <NumberFormat value={totalToShow} />
                </TotalPrice>
              ) : null}
              <ProductLinesPrice />
              <ShowProductsContainer onClick={() => handleClickSeeProducts(order.id)}>
                <ArrowDropdown
                  fill={openProducts[order.id] ? colors.secondary : colors.black}
                  style={{ margin: '0 0.5rem', transform: openProducts[order.id] ? 'rotate(180deg)' : 'none' }}
                />
                {openProducts[order.id] ? (
                  <ShowLessCopy>{t('contractProducts')}</ShowLessCopy>
                ) : (
                  <ShowMoreCopy>{t('seeProducts')}</ShowMoreCopy>
                )}
              </ShowProductsContainer>
            </ProviderDetail>
          </RequestProviderInfoContainer>
          <RequestOrderContainer openProducts={openProducts[order.id]}>
            <RequestRepeatOrderContainer>
              <ActionButton
                onClick={onFilterClick}
                buttonText={t('repeatOrder')}
                helpText={t('repeatOrderHelpText')}
                Icon={CartRepeatIcon}
              />

              {!order?.redeliveryOrderRole && (
                <ActionButton
                  onClick={handleNewOrder}
                  buttonText={t('newOrder')}
                  helpText={t('newOrderHelp')}
                  Icon={EmptyCart}
                />
              )}
              <ActionButton
                onClick={handleClickExcel}
                buttonText={t('downloadOrder')}
                helpText={t('downloadOrderHelpText')}
                Icon={Download}
              />
              {(isLogirestRole || isSupplyRole) && (
                <ActionButton
                  onClick={onLinkRedeliveryOrder}
                  buttonText={t('redeliverOrder')}
                  helpText={t('redeliverOrderSub')}
                  Icon={CartRepeatIcon}
                />
              )}
              {ROLES.ROLE_STEF !== ROLES[role] &&
                order.state === ORDER_STATUS.PR &&
                showCancelOrder &&
                !blockCancelOrderButton && (
                  <ActionButton
                    onClick={handleCancelOrder}
                    buttonText={t('cancelOrder')}
                    helpText={t('cancelOrderHelp')}
                    Icon={Cancelado}
                    disabled={hasNotServedNonConformity}
                    disabledTooltip={t('orderHasNotServedNonConformity')}
                  />
                )}
              {ROLES.ROLE_STEF !== ROLES[role] && order.state === ORDER_STATUS.PR && (
                <ActionButton
                  onClick={handleClickNotServidedOrder}
                  buttonText={t('notServidedOrder')}
                  helpText={t('notServidedHelp')}
                  Icon={ComplaintIcon}
                  disabled={order?.blockOrderNotServedButton === true || blockCancelOrderButton}
                  disabledTooltip={notServedDisabledTooltip}
                />
              )}
              {ROLES.ROLE_STEF !== ROLES[role] && order.state === ORDER_STATUS.RC && !order?.redeliveryOrderRole && (
                <ActionButton
                  onClick={handleClickOpenNoConformities}
                  buttonText={t('openNoConformities')}
                  helpText={t('openNoConformitiesHelpText')}
                  Icon={ComplaintIcon}
                />
              )}
              {order.parentRequest && (
                <SeeApprovedRequestAction onClick={handleClickOpenCarts} type={order.modificationType} />
              )}
            </RequestRepeatOrderContainer>
            <OrderState state={order.state} isDisabled={order?.blockReceptionButton} />
          </RequestOrderContainer>
        </>
      )}

      {openProducts[order.id] && (
        <ProductsContainer>
          {products && (
            <TableHeaderRow>
              <TableHeaderItem>{t('products')}</TableHeaderItem>
              {showPrice && <TableHeaderItem>{t('sum')}</TableHeaderItem>}
              <TableHeaderItem>{t('quantity')}</TableHeaderItem>
            </TableHeaderRow>
          )}
          {productsLoading && !products && (
            <SingleProductRowCL>
              <SingleProductNameHelper>
                <ProductNameLoader />
              </SingleProductNameHelper>
              <SingleProductPriceContainer>
                <ProductInfoLoader />
              </SingleProductPriceContainer>
              <SingleProductQtyContainer>
                <ProductInfoLoader />
              </SingleProductQtyContainer>
              <SingleProductButtonContainer>
                <ProductActionLoader />
              </SingleProductButtonContainer>
            </SingleProductRowCL>
          )}
          {products &&
            get(products, 'lines', []).map((product, index) => {
              const {
                name,
                price,
                measureUnit,
                amount,
                priceUnit,
                product: productData,
                extraServiceDescription,
              } = product
              return (
                <SingleProductRow withPrice={showPrice}>
                  <SingleProductNameHelper>
                    <SingleProductName>
                      <SingleProductNameLabelMobile>{t('product')}:</SingleProductNameLabelMobile> {name}
                      {extraServiceDescription && (
                        <DetailExtraService>
                          <ExtraDesc>{`${t('detail')} ${extraServiceDescription}`}</ExtraDesc>
                        </DetailExtraService>
                      )}
                    </SingleProductName>
                  </SingleProductNameHelper>

                  {showPrice && (
                    <SingleProductPriceContainer>
                      <SingleProductNameLabelMobile>{t('price')}:</SingleProductNameLabelMobile>
                      <SingleProductTotalPrice>
                        <NumberFormat value={price} />
                      </SingleProductTotalPrice>
                      <SingleProductTotalPriceSplit>
                        <Price>
                          <NumberFormat value={priceUnit} suffix={`€/${measureUnit}`} />
                        </Price>
                        <PriceKG />
                      </SingleProductTotalPriceSplit>
                    </SingleProductPriceContainer>
                  )}
                  <SingleProductQtyContainer>
                    <SingleProductTotalQty>
                      <SingleProductTotalQtyLabelMobile>{t('quantity')}:</SingleProductTotalQtyLabelMobile>
                      {amount} {measureUnit}
                    </SingleProductTotalQty>
                    <div style={{ display: 'flex' }}>
                      {productData && (
                        <MinAndMulti>
                          {`${t('min')}: ${financial(productData.min)} / ${t('multi')}: ${financial(
                            productData.multiple
                          )}`}
                        </MinAndMulti>
                      )}
                    </div>
                  </SingleProductQtyContainer>
                  <SingleProductButtonContainer>
                    {productData ? (
                      order.state !== ORDER_STATUS.PR && (
                        <ProductButton
                          {...productData}
                          innerRef={element => setRef(element, index)}
                          onPrevious={id => onPreviuos(id, index)}
                          onNext={id => onNext(id, index)}
                        />
                      )
                    ) : (
                      <NotAvailable>
                        <NotAvailableLiteral>{t('notAvailable')}</NotAvailableLiteral>
                      </NotAvailable>
                    )}
                  </SingleProductButtonContainer>
                </SingleProductRow>
              )
            })}
        </ProductsContainer>
      )}
      <Modal isOpen={showModal} setIsOpen={setShowModal} width='680px' height='256px'>
        <ModalRepeatOrder
          color={colors.secondary}
          onChange={handleChange}
          setShowModal={setShowModal}
          repeatOrder={handleClickRepeatOrder}
          title={t('repeatOrder')}
          message={t('reapeatOrderModalText')}
        />
      </Modal>
      <ModalQAForm showModal={showQAModal} setShowModal={setShowQAModal} data={{ qaData }} orderNumber={order.id} />
      <ModalDownloadEmail
        setShowModal={() => setShowDownloadProviderOrdersExcelModal(false)}
        showModal={showDownloadProviderOrdersExcelModal}
        title={t('downloadOrdersExcelTitle')}
        description={t('downloadOrdersExcelDescription')}
      />
      <ModalDownloadEmail
        setShowModal={() => setShowDownloadQaExcelModal(false)}
        showModal={showDownloadQaExcelModal}
        title={t('downloadQaExcelTitle')}
        description={t('downloadQaExcelDescription')}
      />
      <ModalCancelOrder
        showModal={showCancelOrderModal}
        setShowModal={setShowCancelOrderModal}
        onConfirm={cancelOrder}
        order={order}
        borderRadius='4px'
        bottomBackground='#E7E7E7'
      />
    </>
  )
}

HistoryOrderProduct.propTypes = {
  centerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  order: PropTypes.object,
  smallCard: PropTypes.bool,
}

HistoryOrderProduct.defaultProps = {
  centerId: null,
  order: null,
  smallCard: false,
}

const SeeApprovedRequestAction = ({ onClick, type }) => {
  const { t } = useTranslation()

  const { MODIFIED, AUT } = PROVIDER_ORDERS_MODIFICATION_TYPE
  const isModified = type === MODIFIED
  const isAutomaticallyApproved = type === AUT

  let helperText = t('noModified')
  if (isModified) {
    helperText = t('modified')
  } else if (isAutomaticallyApproved) {
    helperText = t('isAutomaticallyApproved')
  }

  return (
    <RequestActionContainer>
      <RequestRepeatOrder>
        <Approval />
        <button type='button' onClick={onClick}>
          {t('requestOrderStatus.Aprobada')}
        </button>
      </RequestRepeatOrder>
      <HelpText bold={isModified}>{helperText}</HelpText>
    </RequestActionContainer>
  )
}

SeeApprovedRequestAction.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
}

SeeApprovedRequestAction.defaultProps = {
  onClick: () => null,
  type: '',
}

export default HistoryOrderProduct
